import { Component, Input, OnInit } from '@angular/core';
import { plainToClass } from 'class-transformer';
import {
  AppPercentPipe, Property,
  PropertyCorelogicStatsInterface,
  PropertyService,
  PropertyValuation,
  PropertyValuationForm,
  PropertyValuationMessages,
  PropertyValuationService,
} from 'taxtank-core';
import { BaseFormComponent } from '@shared/component/base/base-form.component';
import { CustomCurrencyPipe } from '@shared/pipe/custom-currency/custom-currency.pipe';

/**
 * Property valuation form component. Contain property valuation own fields
 */
@Component({
  selector: 'app-property-valuation-form',
  templateUrl: './property-valuation-form.component.html',
  styleUrls: ['./property-valuation-form.component.scss'],
  standalone: false
})
export class PropertyValuationFormComponent extends BaseFormComponent implements OnInit {
  isCorelogic: boolean;
  isCorelogicAvailable: boolean;
  corelogicStats: PropertyCorelogicStatsInterface;
  // PropertyValuation instance new or existing
  @Input() valuation: PropertyValuation = plainToClass(PropertyValuation, {});
  @Input() property: Property;
  @Input() isSwitcherHidden = false;
  // form with property valuation fields
  @Input() form: PropertyValuationForm;
  currencyTransformer = this.customCurrencyPipe.transform.bind(this.customCurrencyPipe);
  percentTransformer = this.percentPipe.transform.bind(this.percentPipe);
  // Max value by which the growth percentage can deviate
  percentageRange = 3;
  growthPercentMin = 0;
  growthPercentMax = 10;
  // Step by which the growth percentage can change
  percentageStep = 0.1;
  isManualMV = false;

  constructor(
    private propertyValuationService: PropertyValuationService,
    private propertyService: PropertyService,
    public customCurrencyPipe: CustomCurrencyPipe,
    public percentPipe: AppPercentPipe,
  ) {
    super();
  }

  ngOnInit(): void {
    this.valuation.property = this.property;
    this.isCorelogic = this.isCorelogicAvailable = !this.valuation.id && this.property.isCorelogicAvailable();
    if (this.isCorelogic) {
      this.propertyService.getCorelogicStats(this.property).subscribe(corelogicStats => {
        this.corelogicStats = corelogicStats;
        if (corelogicStats.growthPercent) {
          this.growthPercentMin = corelogicStats.growthPercent - this.percentageRange;
          this.growthPercentMax = corelogicStats.growthPercent + this.percentageRange;
        }
        this.isManualMV = !corelogicStats.marketValue;
        this.property.growthPercent = this.corelogicStats.growthPercent ?? 5;
        this.valuation.marketValue = this.corelogicStats.marketValue;
        this.buildForm();
      });
    }

    if (!this.form) {
      this.buildForm();
    }
  }

  buildForm(): void {
    this.form = new PropertyValuationForm(this.valuation, this.property);
  }

  save(valuation: PropertyValuation): void {
    valuation.id ? this.put(valuation) : this.post(valuation);
  }

  post(valuation: PropertyValuation): void {
    this.propertyValuationService.post(valuation).subscribe(() => {
      this.saved.emit(valuation);
      this.toastService.success(PropertyValuationMessages.CREATED);
    });
    if (!this.form.value.isCorelogic) {
      return;
    }

    this.property.growthPercent = this.form.value.growthPercent;
    this.propertyService.put(this.property).subscribe();
  }

  put(valuation: PropertyValuation): void {
    this.propertyValuationService.put(valuation).subscribe(() => {
      this.saved.emit(valuation);
      this.toastService.success(PropertyValuationMessages.UPDATED);
    });
  }
}
